const formGenerate = [
  {
    label: "STUDENT_MANAGEMENT.FORM.TITLE_LABEL",
    name: "title",
    placeholder: "STUDENT_MANAGEMENT.FORM.TITLE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.TITLE_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FIRST_NAME_LABEL",
    name: "first_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.FIRST_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FIRST_NAME_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.LAST_NAME_LABEL",
    name: "last_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.LAST_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.LAST_NAME_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MIDLE_NAME_LABEL",
    name: "middle_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.MIDLE_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.MIDLE_NAME_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_LABEL",
    name: "phone_number",
    placeholder: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.EMAIL_LABEL",
    name: "email",
    placeholder: "STUDENT_MANAGEMENT.FORM.EMAIL_PLACEHOLDER",
    type: "input",
    typeForm: "email",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: true,
    titleRequired: "STUDENT_MANAGEMENT.FORM.EMAIL_REQUIRED",
    disable: false,
    section: "section_1",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "divider",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.EDUCATION_LEVEL_LABEL",
    name: "education_level",
    placeholder: "STUDENT_MANAGEMENT.FORM.EDUCATION_LEVEL_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.EDUCATION_LEVEL_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NAME_INSTITUTE_LABEL",
    name: "name_of_the_institute",
    placeholder: "STUDENT_MANAGEMENT.FORM.NAME_INSTITUTE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 5, lg: 5 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.NAME_INSTITUTE_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.YEAR_GRADUATED_LABEL",
    name: "year_of_graduated",
    placeholder: "STUDENT_MANAGEMENT.FORM.YEAR_GRADUATED_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.YEAR_GRADUATED_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.GPA_LABEL",
    name: "gpa",
    placeholder: "STUDENT_MANAGEMENT.FORM.GPA_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.GPA_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MY_DHAMMA_QUALIFICATIONS_LABEL",
    name: "my_dhamma_qualifications",
    placeholder: "STUDENT_MANAGEMENT.FORM.MY_DHAMMA_QUALIFICATIONS_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.MY_DHAMMA_QUALIFICATIONS_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.ENGLISH_QUALIFICATIONS_LABEL",
    name: "english_qualification",
    placeholder: "STUDENT_MANAGEMENT.FORM.ENGLISH_QUALIFICATIONS_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.ENGLISH_QUALIFICATIONS_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DEGREE_LABEL",
    name: "degree",
    placeholder: "STUDENT_MANAGEMENT.FORM.DEGREE_PLACEHOLDER",
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "degree",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DEGREE_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FACULTY_LABEL",
    name: "faculty",
    placeholder: "STUDENT_MANAGEMENT.FORM.FACULTY_PLACEHOLDER",
    type: "select",
    typeForm: "text",
    formSize: "small",
    optionName: "faculty",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FACULTY_REQUIRED",
    disable: false,
    section: "section_2",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "divider",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PERSONAL_INFOMATION_HEADER",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_NUMBER_LABEL",
    name: "passport_no",
    placeholder: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_NUMBER_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 5, lg: 5 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_NUMBER_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_ISSUE_LABEL",
    name: "passport_date_issue",
    placeholder: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_ISSUE_PLACEHOLDER",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3.5, lg: 3.5 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_ISSUE_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_EXPIRY_LABEL",
    name: "passport_date_expiry",
    placeholder: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_EXPIRY_PLACEHOLDER",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3.5, lg: 3.5 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PASSPOSRT_DATE_EXPIRY_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.WEIGHT_LABEL",
    name: "weight",
    placeholder: "STUDENT_MANAGEMENT.FORM.WEIGHT_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 1.3, lg: 1.3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.WEIGHT_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.HEIGHT_LABEL",
    name: "height",
    placeholder: "STUDENT_MANAGEMENT.FORM.HEIGHT_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 1.3, lg: 1.3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.HEIGHT_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.BLOOD_TYPE_LABEL",
    name: "blood_type",
    placeholder: "STUDENT_MANAGEMENT.FORM.BLOOD_TYPE_PLACEHOLDER",
    type: "input",
    typeForm: "string",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 1.3, lg: 1.3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.BLOOD_TYPE_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DATE_OF_BIRTH_LABEL",
    name: "date_of_birth",
    placeholder: "STUDENT_MANAGEMENT.FORM.DATE_OF_BIRTH_PLACEHOLDER",
    type: "date",
    typeForm: "date",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2.1, lg: 2.1 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DATE_OF_BIRTH_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PLACE_OF_BIRTH_LABEL",
    name: "place_of_birth",
    placeholder: "STUDENT_MANAGEMENT.FORM.PLACE_OF_BIRTH_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 4, lg: 4 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PLACE_OF_BIRTH_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.RACE_ETHNIC_LABEL",
    name: "race_ethinc",
    placeholder: "STUDENT_MANAGEMENT.FORM.RACE_ETHNIC_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 2, lg: 2 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.RACE_ETHNIC_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NATIONALITY_LABEL",
    name: "nationality",
    placeholder: "STUDENT_MANAGEMENT.FORM.NATIONALITY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.NATIONALITY_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.RELIGION_LABEL",
    name: "religion",
    placeholder: "STUDENT_MANAGEMENT.FORM.RELIGION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.RELIGION_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.OCCUPATION_LABEL",
    name: "occupation",
    placeholder: "STUDENT_MANAGEMENT.FORM.OCCUPATION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.OCCUPATION_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DATE_OF_ORDINATION_LABEL",
    name: "date_ordination",
    placeholder: "STUDENT_MANAGEMENT.FORM.DATE_OF_ORDINATION_PLACEHOLDER",
    type: "date",
    typeForm: "date",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DATE_OF_ORDINATION_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.SECT_LABEL",
    name: "sect",
    placeholder: "STUDENT_MANAGEMENT.FORM.SECT_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.SECT_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DISABILITY_LABEL",
    name: "disability",
    placeholder: "STUDENT_MANAGEMENT.FORM.DISABILITY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DISABILITY_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_LABEL",
    name: "number_of_sibling",
    placeholder: "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_IS_STUDY_LABEL",
    name: "number_of_sibling_whom_still_study",
    placeholder:
      "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_IS_STUDY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired:
      "STUDENT_MANAGEMENT.FORM.NUMBER_OF_SIBLING_IS_STUDY_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.SKILL_INTEREST_LABEL",
    name: "skills_interests",
    placeholder: "STUDENT_MANAGEMENT.FORM.SKILL_INTEREST_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.SKILL_INTEREST_REQUIRED",
    disable: false,
    section: "section_personal_info",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "divider",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.ADDRESS_HEADER",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NAME_TEMPLE_LABEL",
    name: "name_of_the_temple",
    placeholder: "STUDENT_MANAGEMENT.FORM.NAME_TEMPLE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.NAME_TEMPLE_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.NAME_ABBOT_LABEL",
    name: "name_of_the_abbot",
    placeholder: "STUDENT_MANAGEMENT.FORM.NAME_ABBOT_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.NAME_ABBOT_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_LABEL",
    name: "house_no",
    placeholder: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_LABEL",
    name: "street_road",
    placeholder: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.VILLAGE_LABEL",
    name: "village",
    placeholder: "STUDENT_MANAGEMENT.FORM.VILLAGE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.VILLAGE_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_LABEL",
    name: "town_city",
    placeholder: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DISTRICT_LABEL",
    name: "district",
    placeholder: "STUDENT_MANAGEMENT.FORM.DISTRICT_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DISTRICT_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PROVINCE_LABEL",
    name: "province",
    placeholder: "STUDENT_MANAGEMENT.FORM.PROVINCE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PROVINCE_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.STATE_LABEL",
    name: "state",
    placeholder: "STUDENT_MANAGEMENT.FORM.STATE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.STATE_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.COUNTRY_LABEL",
    name: "country",
    placeholder: "STUDENT_MANAGEMENT.FORM.COUNTRY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.COUNTRY_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_LABEL",
    name: "postal_zipcode",
    placeholder: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_REQUIRED",
    disable: false,
    section: "section_address",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "divider",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PARENT_HEADER",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FATHER_NAME_LABEL",
    name: "father_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.FATHER_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FATHER_NAME_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FATHER_STATUS_LABEL",
    name: "father_status",
    placeholder: "STUDENT_MANAGEMENT.FORM.FATHER_STATUS_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    optionName: "parent_status",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FATHER_STATUS_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FATHER_OCCUPATION_LABEL",
    name: "father_occupation",
    placeholder: "STUDENT_MANAGEMENT.FORM.FATHER_OCCUPATION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FATHER_OCCUPATION_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.FATHER_INCOME_PER_YEAR_LABEL",
    name: "father_income_per_year",
    placeholder: "STUDENT_MANAGEMENT.FORM.FATHER_INCOME_PER_YEAR_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    optionName: "salary_rate",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.FATHER_INCOME_PER_YEAR_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MOTHER_NAME_LABEL",
    name: "mother_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.MOTHER_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.MOTHER_NAME_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MOTHER_STATUS_LABEL",
    name: "mother_status",
    placeholder: "STUDENT_MANAGEMENT.FORM.MOTHER_STATUS_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    optionName: "parent_status",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.SKILL_INTEREST_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MOTHER_OCCUPATION_LABEL",
    name: "mother_occupation",
    placeholder: "STUDENT_MANAGEMENT.FORM.MOTHER_OCCUPATION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.MOTHER_OCCUPATION_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.MOTHER_INCOME_PER_YEAR_LABEL",
    name: "mother_income_per_year",
    placeholder: "STUDENT_MANAGEMENT.FORM.MOTHER_INCOME_PER_YEAR_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    optionName: "salary_rate",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.MOTHER_INCOME_PER_YEAR_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PARENT_MARRIAGE_STATUS_LABEL",
    name: "parent_marriage_status",
    placeholder: "STUDENT_MANAGEMENT.FORM.PARENT_MARRIAGE_STATUS_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PARENT_MARRIAGE_STATUS_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "free-space",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 0, md: 9, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PERSON_NAME_LABEL",
    name: "referent_person_name",
    placeholder: "STUDENT_MANAGEMENT.FORM.PERSON_NAME_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PERSON_NAME_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PERSON_RELATION_LABEL",
    name: "relationship",
    placeholder: "STUDENT_MANAGEMENT.FORM.PERSON_RELATION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PERSON_RELATION_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PERSON_OCCUPATION_LABEL",
    name: "referent_person_occupation",
    placeholder: "STUDENT_MANAGEMENT.FORM.PERSON_OCCUPATION_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PERSON_OCCUPATION_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PERSON_INCOME_PER_YEAR_LABEL",
    name: "referent_person_income_per_year",
    placeholder: "STUDENT_MANAGEMENT.FORM.PERSON_INCOME_PER_YEAR_PLACEHOLDER",
    type: "select",
    typeForm: "select",
    optionName: "salary_rate",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PERSON_INCOME_PER_YEAR_REQUIRED",
    disable: false,
    section: "section_parent",
  },

  {
    label: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_LABEL",
    name: "house_no",
    placeholder: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.HOUSE_NO_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_LABEL",
    name: "street_road",
    placeholder: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.STREET_ROAD_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.VILLAGE_LABEL",
    name: "village",
    placeholder: "STUDENT_MANAGEMENT.FORM.VILLAGE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.VILLAGE_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_LABEL",
    name: "town_city",
    placeholder: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.TOWN_CITY_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.DISTRICT_LABEL",
    name: "district",
    placeholder: "STUDENT_MANAGEMENT.FORM.DISTRICT_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.DISTRICT_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PROVINCE_LABEL",
    name: "province",
    placeholder: "STUDENT_MANAGEMENT.FORM.PROVINCE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PROVINCE_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.STATE_LABEL",
    name: "state",
    placeholder: "STUDENT_MANAGEMENT.FORM.STATE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.STATE_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.COUNTRY_LABEL",
    name: "country",
    placeholder: "STUDENT_MANAGEMENT.FORM.COUNTRY_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.COUNTRY_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_LABEL",
    name: "postal_zipcode",
    placeholder: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_PLACEHOLDER",
    type: "input",
    typeForm: "text",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.POSTAL_ZIP_CODE_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_LABEL",
    name: "phone_number",
    placeholder: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_PLACEHOLDER",
    type: "input",
    typeForm: "number",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.PHONE_NUMBER_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "STUDENT_MANAGEMENT.FORM.EMAIL_LABEL",
    name: "email",
    placeholder: "STUDENT_MANAGEMENT.FORM.EMAIL_PLACEHOLDER",
    type: "input",
    typeForm: "email",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 3, lg: 3 },
    isRequired: false,
    titleRequired: "STUDENT_MANAGEMENT.FORM.EMAIL_REQUIRED",
    disable: false,
    section: "section_parent",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "divider",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  // Add more fields as needed
];

export default formGenerate;
